import { Globe, Brain, Wrench, Layers, Target } from "lucide-react";

const WhyUs = () => {
  const reasons = [
    {
      icon: Globe,
      title: "Warm Access to European & UK Investors",
      description:
        "We have direct warm connections with funds investing in defense-tech, dual-use, and deep-tech across London, Berlin, Amsterdam, Warsaw and Tallinn.",
    },
    {
      icon: Brain,
      title: "Deep Understanding of the Landscape",
      description:
        "We understand how investment decisions are made in European VC, government-backed funds, and dual-use accelerators.",
    },
    {
      icon: Wrench,
      title: "Hands-On Execution",
      description:
        "We don't deliver slides and disappear. We manage outreach, speak with investors, prepare you for Q&A, and support negotiations.",
    },
    {
      icon: Layers,
      title: "Cross-Disciplinary Expertise",
      description:
        "Our team combines product, GTM, legal, strategic, and operational experience — a rare combination in early-stage fundraising services.",
    },
    {
      icon: Target,
      title: "Aligned Incentives",
      description:
        "We work on a monthly retainer plus success fee. We succeed only when you succeed.",
    },
  ];

  return (
    <section id="why-us" className="py-24 md:py-32 bg-muted/30">
      <div className="container px-6">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
            Why Work With Us
          </h2>
          <p className="text-lg text-muted-foreground mt-6">
            A partner built for the unique challenges of deep-tech fundraising
          </p>
        </div>

        {/* Reasons grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`group p-8 rounded-xl border border-border bg-card/50 hover:bg-card hover:border-primary/30 transition-all duration-300 ${
                index === 4 ? "lg:col-span-1 md:col-span-2 lg:col-start-2" : ""
              }`}
            >
              {/* Icon */}
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-5 group-hover:bg-primary/20 transition-colors duration-300">
                <reason.icon className="w-5 h-5 text-primary" />
              </div>

              {/* Content */}
              <h3 className="font-display text-lg font-semibold text-foreground mb-3">
                {reason.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
